<div class="page-container">
  @if (state() === 'loading') {
    <div class="loading-container flex flex-column flex-align-center p-lg">
      <app-spinner />
    </div>
  }

  @if (state() === 'error') {
    <div class="error-container p-lg" data-testid="billing-settings-error">
      <p>{{ 'billingSettings.loadError' | translate }}</p>
    </div>
  }

  @if (state() === 'loaded' && subscription(); as sub) {
    <div class="billing-content flex flex-column gap-lg">
      <app-card>
        <div class="p-lg flex flex-column gap-md">
          <div class="plan-header flex flex-justify-space-between flex-align-center">
            <div>
              <h2>{{ sub.plan.name }}</h2>
              <span class="plan-price">{{ formatPrice(sub.plan.priceMonthlyCents) }}</span>
            </div>
            <app-chip [color]="sub.status === 'active' ? 'success' : 'warning'" data-testid="billing-status-chip">
              {{ sub.status }}
            </app-chip>
          </div>

          <div class="usage-row">
            <div class="usage-label">
              <span>{{ 'billingSettings.assetUsage' | translate }}</span>
              <span>{{ sub.assetUsage.used }} / {{ sub.assetUsage.limit === -1 ? ('pricing.unlimitedAssets' | translate) : sub.assetUsage.limit }}</span>
            </div>
            <div class="usage-bar">
              <div class="usage-bar-fill" [style.width.%]="usagePercent(sub.assetUsage.used, sub.assetUsage.limit)"></div>
            </div>
          </div>

          <div class="usage-row">
            <div class="usage-label">
              <span>{{ 'billingSettings.formUsage' | translate }}</span>
              <span>{{ sub.customFormUsage.used }} / {{ sub.customFormUsage.limit === -1 ? ('pricing.unlimitedForms' | translate) : sub.customFormUsage.limit }}</span>
            </div>
            <div class="usage-bar">
              <div class="usage-bar-fill" [style.width.%]="usagePercent(sub.customFormUsage.used, sub.customFormUsage.limit)"></div>
            </div>
          </div>

          <app-button variant="outlined" [disabled]="actionInFlight()" (click)="manageBilling()" data-testid="manage-billing-button">
            {{ 'billingSettings.manageBilling' | translate }}
          </app-button>
        </div>
      </app-card>

      @if (otherPlans().length > 0) {
        <app-card>
          <div class="p-lg flex flex-column gap-md">
            <h3>{{ 'billingSettings.upgradeTitle' | translate }}</h3>
            <div class="plan-options">
              @for (plan of otherPlans(); track plan.id) {
                <div class="plan-option flex flex-justify-space-between flex-align-center">
                  <div>
                    <strong>{{ plan.name }}</strong>
                    <span class="plan-price">{{ formatPrice(plan.priceMonthlyCents) }}</span>
                  </div>
                  <app-button variant="filled" [disabled]="actionInFlight()" (click)="upgradeToPlan(plan)"
                    [attr.data-testid]="'upgrade-to-' + plan.id">
                    {{ 'billingSettings.switchPlan' | translate }}
                  </app-button>
                </div>
              }
            </div>
          </div>
        </app-card>
      }

      @if (formPacks().length > 0) {
        <app-card>
          <div class="p-lg flex flex-column gap-md">
            <h3>{{ 'billingSettings.formPacksTitle' | translate }}</h3>
            <div class="plan-options">
              @for (pack of formPacks(); track pack.id) {
                <div class="plan-option flex flex-justify-space-between flex-align-center">
                  <div>
                    <strong>{{ pack.formCount }} {{ 'pricing.customForms' | translate }}</strong>
                    <span class="plan-price">{{ formatPrice(pack.priceCents) }}</span>
                  </div>
                  <app-button variant="outlined" [disabled]="actionInFlight()" (click)="buyFormPack(pack)"
                    [attr.data-testid]="'buy-' + pack.id">
                    {{ 'billingSettings.buyPack' | translate }}
                  </app-button>
                </div>
              }
            </div>
          </div>
        </app-card>
      }
    </div>
  }
</div>
